import { useCallback, useMemo, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import AvatarBox from './AvatarBox';
import InputSearchSuffixIcon from 'components/InputSearchSuffixIcon';
import { IStaffItemData } from 'services/shop/types/staff';
import Box from 'components/Box';
import Button from 'components/Button';

type Props = {
  value?: string[];
  onChange?: (value: string[]) => void;
};

const StaffListChooseMultipleUI = ({ value = [], onChange = () => undefined }: Props) => {

  const [searchText, setSearchText] = useState('');
  const _staffList = shopSelectors.data.staffs();

  const staffList = useMemo(() => {
    // const data = _staffList.filter(o => !o.anyBody) || [];
    const _searchStr = searchText.trim().toLocaleLowerCase();
    if (!_searchStr) return _staffList;
    return _staffList.filter(o => o.nickName?.toLocaleLowerCase().includes(_searchStr));
  }, [searchText, _staffList]);

  const hanleClickStaff = useCallback((item: IStaffItemData) => {
    if (!value) {
      onChange?.([item.id]);
    } else if (value?.includes(item.id)) {
      onChange?.(value.filter(id => id !== item.id));
    } else {
      onChange?.([...value, item.id]);
    }
  }, [value, onChange]);


  const hanleClickAllStaff = useCallback(() => {
    if (value.length === 0) {
      onChange?.(_staffList.map(o => o.id));
    } else {
      onChange?.([]);
    }
  }, [value, onChange, _staffList]);

  return (
    <Container>
      <Box display='flex' alignItems='center' gap='2'>
        <InputSearchSuffixIcon value={searchText} onChange={setSearchText} />
        <Button ntype='DARK_BLUE' onClick={hanleClickAllStaff}>Select All Staff</Button>
      </Box>

      <ScrollContainer>
        <div className="scroll-wrapper">
          <StaffListContainer>
            {staffList.map((item) => {
              const isSelected = value?.includes(item.id);
              return (
                <AvatarBox
                  key={item.id}
                  anybody={item.anyBody}
                  onClick={() => hanleClickStaff(item)}
                  src={item.urlImage}
                  name={item.nickName}
                  selected={isSelected}
                  cashier
                  className={'cashier-staff-box'}
                />
              );
            })}
          </StaffListContainer>
        </div>
      </ScrollContainer>


    </Container>
  );
};

export default StaffListChooseMultipleUI;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  align-self: stretch;
`;

const ScrollContainer = styled(Box)`
  flex: 1;
  position: relative;
  .scroll-wrapper {
    position: absolute;
    inset: 0;
    overflow: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
`;

const StaffListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(140px, 1fr));
  gap: 16px;
  .cashier-staff-box {
        width: 100%;
        padding: 0.5rem 0;
         .AnyBodyImage {
            width: 7.5rem !important;
            min-height: 7.5rem;
          }
        &.row-5 {
          .circle-avatar {
            width: 7rem;
            min-height: 7rem;
          }
          .AnyBodyImage {
            width: 6.5rem !important;
            min-height: 6.5rem;
          }
        }
      }
`;